export const STUDENT_ID_STATUSES = {
  EMPTY: 'empty',
  PENDING: 'pending',
  CANCELED: 'declined',
  ACCEPTED: 'approved',
};
